import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NotificationService} from "../notification.service";
import {tap, debounceTime} from 'rxjs/operators';
import {Notification} from "../../../model/view/Notification";

@Component({
  selector: 'v-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationMessageComponent implements OnInit {
  showNotification = false;
  notification: Notification;
  notificationTime = 4000;

  constructor(
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.notificationService.notifyRequest$.pipe(
      tap((notification: Notification) => {
        this.notification = notification;
        this.showNotification = true
      }),
      debounceTime(this.notificationTime),
      tap(() => {
        this.showNotification = false;
        this.notification = null;
      })
    ).subscribe(() => this.cd.detectChanges())
  }

  close() {
    this.showNotification = false;
  }
}
